import { render, staticRenderFns } from "./WorkflowFormBuilderTodoDrawer.vue?vue&type=template&id=6bc2344b&"
import script from "./WorkflowFormBuilderTodoDrawer.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderTodoDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports